import { memo } from 'react';
import styled from '@emotion/styled';
import { Search as SearchIcon } from '@mui/icons-material';
import { Circle, GoogleMap, Marker, StandaloneSearchBox } from '@react-google-maps/api';
import { useTranslation } from 'src/hooks';
import { SvgIcon, TextField } from 'src/components/atoms';
import { MapCoordinates } from 'src/components/pages/mymes/editor/blobs/editor/context';
import { mapContainerStyles } from './MapSkeleton';

const StyledContainer = styled.div`
  margin-top: 1rem;
`;

interface Props {
  map: google.maps.Map | null;
  centerPoint: MapCoordinates;
  marker: google.maps.LatLng | null;
  radius: number;
  zoom: number;
  onPlacesChanged: () => void;
  onLoad: (map: google.maps.Map) => void;
  onUnmount: (_map: google.maps.Map) => void;
  searchBoxRef: React.MutableRefObject<StandaloneSearchBox | null>;
  handleSetMarkerOnTheMap: (e: google.maps.MapMouseEvent) => void;
}

export const Map = memo(
  ({
    map,
    centerPoint,
    marker,
    radius,
    zoom,
    onPlacesChanged,
    onLoad,
    onUnmount,
    searchBoxRef,
    handleSetMarkerOnTheMap
  }: Props) => {
    const { t } = useTranslation();

    return (
      <>
        <StyledContainer id='searchbox'>
          <StandaloneSearchBox onPlacesChanged={onPlacesChanged} bounds={map?.getBounds()} ref={searchBoxRef}>
            <TextField
              fullWidth
              label={t('pages.mymes.editor.blobs.editor.map_search_field')}
              InputProps={{
                startAdornment: (
                  <SvgIcon>
                    <SearchIcon />
                  </SvgIcon>
                )
              }}
            />
          </StandaloneSearchBox>
        </StyledContainer>
        <GoogleMap
          mapContainerStyle={{ ...mapContainerStyles, margin: '0.75rem 0', position: 'relative' }}
          zoom={zoom}
          center={centerPoint}
          onLoad={onLoad}
          onUnmount={onUnmount}
          onClick={handleSetMarkerOnTheMap}
        >
          {marker && (
            <>
              <Circle center={marker} radius={radius} onClick={handleSetMarkerOnTheMap} />
              <Marker position={marker} />
            </>
          )}
        </GoogleMap>
      </>
    );
  }
);
